import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc
} from "firebase/firestore";
import { db } from "../firebase/config";
import "./ShopTab.css";
import Emoji from "./Emoji";

function ShopTab() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState({
    title: "",
    description: "",
    image: "",
    price: 0
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    const snap = await getDocs(collection(db, "shopItems"));
    const fetchedItems = snap.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .sort((a, b) => {
        if ((a.active === false) !== (b.active === false)) {
          return a.active === false ? -1 : 1;
        }
        return (a.title || "").localeCompare(b.title || "", "uk");
      });
    setItems(fetchedItems);
  };

  const handleSave = async (item) => {
    if (!item.title || !item.price) return;

    if (item.id) {
      await updateDoc(doc(db, "shopItems", item.id), {
        ...item,
        price: Number(item.price),
        active: true,
      });
    } else {
      await addDoc(collection(db, "shopItems"), {
        ...item,
        price: Number(item.price),
        active: true,
      });
    }

    setEditingItem(null);
    setShowModal(false);
    setNewItem({ title: "", description: "", image: "", price: 0 });
    loadItems();
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "shopItems", id));
    loadItems();
  };

  const filtered = items.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="shop-tab">
      <div className="shop-header">
        <h2>Магазин</h2>
        <div className="task-controls">
           <input
          type="text"
          placeholder="Пошук товарів..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={() => setShowModal(true)}>Додати пропозицію</button>
      </div>
      </div>
      <div className="shop-list">
        {filtered.map(item => (
          <div key={item.id} className="shop-card">
            <img src={item.image} alt={item.title} className="shop-image" />
            <div className="shopmain"><h4>{item.title}</h4>
            {item.active === false && <span className="inactive-label">Неактивний</span>}
            <div className="shop-actions">
              <button onClick={() => setEditingItem(item)}><Emoji label="Редагувати" symbol="✏️" /></button>
              <button onClick={() => handleDelete(item.id)}><Emoji label="Видалити" symbol="🗑️" /></button>
            </div>
            </div>
            <p>{item.description}</p>
            <p><Emoji label="Кубок" symbol="🏆" /> {item.price} балів</p>

          </div>
        ))}
      </div>

      {(showModal || editingItem) && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <h3>{editingItem ? "Редагувати пропозицію" : "Нова пропозиція"}</h3>

            <label>Назва:</label>
            <input
              value={(editingItem || newItem).title}
              onChange={(e) =>
                editingItem
                  ? setEditingItem({ ...editingItem, title: e.target.value })
                  : setNewItem({ ...newItem, title: e.target.value })
              }
            />

            <label>Опис:</label>
            <textarea
              value={(editingItem || newItem).description}
              onChange={(e) =>
                editingItem
                  ? setEditingItem({ ...editingItem, description: e.target.value })
                  : setNewItem({ ...newItem, description: e.target.value })
              }
            />

            <label>Зображення (URL):</label>
            <input
              value={(editingItem || newItem).image}
              onChange={(e) =>
                editingItem
                  ? setEditingItem({ ...editingItem, image: e.target.value })
                  : setNewItem({ ...newItem, image: e.target.value })
              }
            />

            <label>Ціна (бали):</label>
            <input
              type="number"
              value={(editingItem || newItem).price}
              onChange={(e) =>
                editingItem
                  ? setEditingItem({ ...editingItem, price: e.target.value })
                  : setNewItem({ ...newItem, price: e.target.value })
              }
            />

            <div className="shop-modal-actions">
              <button className="shop-save-btn" onClick={() => handleSave(editingItem || newItem)}>Зберегти</button>
              <button className="shop-cancel-btn" onClick={() => { setEditingItem(null); setShowModal(false); }}>Закрити</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ShopTab;
